module.exports = __webpack_public_path__ + "static/img/profile-mockup.2c713b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-mockup.png
// module id = 57
// module chunks = 0